<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <div class="admin-add-products fullheight">
        <v-toolbar dark :color="'#9e9e9e'">
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title
            ><h1
              class="header-tittle"
              :style="{ color: colorsGeneralSecondary }"
            >
              {{ title }}
            </h1>
          </v-toolbar-title>
        </v-toolbar>

        <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>

        <v-container fluid>
          <v-form
            ref="form"
            v-model="isValid"
            lazy-validation
            @submit.prevent="submitForm"
          >
            <v-row>
              <v-col cols="12" sm="2" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Nombre :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="9" class="py-0 py-sm-1">
                <v-text-field
                  v-model="input.name"
                  :rules="validationRules.name"
                  required
                  placeholder="E.g. Bebidas"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="2" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Categoría :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="9" class="py-0 py-sm-1">
                <v-select
                  v-model="input.category_id"
                  :items="categoriesCollection"
                  :rules="validationRules.category"
                  item-text="name"
                  item-value="id"
                  label="Selecciona categoría"
                ></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="2" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Orden :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="9" class="py-0 py-sm-1">
                <v-text-field
                  :rules="validationRules.sort"
                  v-model="input.sort"
                  type="number"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col align="center">
                <div class="my-2 mr-5">
                  <v-btn
                    dense
                    outlined
                    :disabled="!isValid"
                    :style="adminNavigationBackTheme"
                    type="submit"
                  >
                    Guardar
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import {
  saveSubCategory,
  subCategoriesCollection,
  updateSubCategory
} from "@/collections/subCategories";
import { categoriesCollection, updateCategory } from "@/collections/categories";
import moment from "moment";
import Loader from "../../common/Loader";

export default {
  name: "sub-categories-dialog",
  components: { Loader },
  data: () => ({
    itemId: "addSubCat",
    dialog: false,
    title: "",
    isValid: false,
    validationRules: {
      name: [v => (!!v && !!v.trim()) || "Nombre es requerido"],
      sort: [
        v => !!v || "Orden es requerido",
        v => (!!v && parseInt(v) > 0) || "Por favor, introduce un orden válido"
      ],
      category: [v => !!v || "Por favor, selecciona una categoría"]
    },
    categoriesCollection: [],
    subCategoriesCollection: [],
    lastCategoryId: "",
    lastCategory: {
      name: "",
      sort: 1,
      product_type_id: ""
    },
    input: {
      name: "",
      category_id: "",
      sort: 1
    },
    dialogLoader: true
  }),
  firestore() {
    return {
      categoriesCollection: categoriesCollection,
      subCategoriesCollection: subCategoriesCollection
    };
  },
  methods: {
    async submitForm() {
      if (!this.$refs.form.validate()) {
        this.showErrorMessage("Revisa el formulario");
        return;
      }

      try {
        if (this.itemId === "addSubCat") {
          // Create New

          let found = this.subCategoriesCollection.some(
            x =>
              x.name.toLowerCase().trim() ===
              this.input.name.toLowerCase().trim()
          );
          if (found) {
            this.showErrorMessage("El nombre debe ser único");
            return;
          }

          await saveSubCategory(this.buildSubCategory());
          await this.updateCategory();
        } else {
          // check update unique name
          let found = this.subCategoriesCollection.some(
            x =>
              x.name.toLowerCase().trim() ===
                this.input.name.toLowerCase().trim() && x.id !== this.itemId
          );
          if (found) {
            this.showErrorMessage("El nombre debe ser único");
            return;
          }
          // Update Existing
          await updateSubCategory(this.itemId, this.buildSubCategory());
          await this.updateCategory();
        }
        this.showSuccessMessage("Subcategoría guardada");

        this.close();
      } catch (error) {
        this.setlogError(
          "save/update_sub_category",
          "Obtained error message in submitForm()",
          error.stack,
          this.$options.name
        );
        this.showErrorMessage("Algo salió mal");
      }
    },
    buildSubCategory() {
      let now = moment().format();
      return { ...this.input, updated_on: now };
    },
    async updateCategory() {
      try {
        let now = moment().format();
        let category = this.buildCategory(
          this.categoriesCollection.find(x => x.id === this.input.category_id)
        );

        await updateCategory(this.input.category_id, {
          ...category,
          hasSubCategories: true,
          updated_on: now
        });

        if (
          this.lastCategoryId !== "" &&
          this.input.category_id !== this.lastCategoryId
        ) {
          let found = this.subCategoriesCollection.find(
            x => x.category_id === this.lastCategoryId
          );
          if (!found) {
            await updateCategory(this.lastCategoryId, {
              ...this.lastCategory,
              hasSubCategories: false,
              updated_on: now
            });
          }
        }
      } catch (error) {
        this.setlogError(
          "save/update_category",
          "Obtained error message in updateCategory()",
          error.stack,
          this.$options.name
        );
      }
    },
    buildCategory(category) {
      return {
        name: category.name,
        sort: category.sort,
        product_type_id: category.product_type_id
      };
    },
    open(itemId) {
      this.dialog = true;
      this.itemId = itemId;

      if (this.itemId === "addSubCat") {
        setTimeout(() => {
          this.title = "Crear subcategoría";
        }, 100);

        this.dialogLoader = false;
        return;
      } else {
        setTimeout(() => {
          this.title = "Editar subcategoría";
        }, 100);
      }

      setTimeout(() => {
        let subCategory = this.subCategoriesCollection.find(
          x => x.id === this.itemId
        );
        if (subCategory) {
          this.input = subCategory;
          this.lastCategoryId = subCategory.category_id;
          this.lastCategory = this.buildCategory(
            this.categoriesCollection.find(
              x => x.id === subCategory.category_id
            )
          );
        }
        this.dialogLoader = false;
      }, 500);
    },
    close() {
      this.dialog = false;
      this.input = {
        name: "",
        category_id: "",
        sort: 1
      };
      this.$refs.form.resetValidation();
    }
  }
};
</script>

<style scoped lang="scss"></style>
